var map = {
	"./accessibility.html": 22993,
	"./contribute/support-and-request.html": 92494,
	"./design/helpers.html": 28341,
	"./design/index.html": 98228,
	"./design/typography.html": 5379,
	"./index.html": 13565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93436;